// @core/api/endpoints/localization/create_locale.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateLocaleRequest,
  LocaleResponse,
} from '../../../types/localization';

const BASE_PATH = '/localization';

/**
 * Create a locale
 * Defines a new locale (language + region) on the platform. Once created, translations can be added for this locale.
 */
export async function CreateLocale(
  data: CreateLocaleRequest,
  options?: RequestOptions
): Promise<LocaleResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/localization/locales`;
  const requestOptions = options;
  return client.post<LocaleResponse>(requestPath, data, requestOptions);
}
